import { AxiosError } from 'axios';
import instance from '../config/axios';
import { ShippingInfo } from '../interface/interface';
import { Endpoints } from './endPoints';

export const saveGuestShippingInfo = async (shippingInfo: ShippingInfo) => {
  try {
    const response = await instance({
      url: Endpoints.SAVE_SHIPPING_INFO,
      data: {
        ...shippingInfo,
        guestEmail: sessionStorage.getItem('guestEmail'),
        guestCartId: sessionStorage.getItem('guestCartId'),
      },
      method: 'POST',
    });
    return response.data;
  } catch (e) {
    console.log('Unable to clear cart', e);
    return (e as AxiosError).response?.status;
  }
};
